import { addTemplatesThunk } from "features/Accounts/state/thunks/AccountTemplatesThunk";
import Templates from "features/Accounts/Templates/Templates";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { useEventCallback } from "hooks/useEventCallback";
import { bindAction, type IWizardStep } from "interfaces";
import { useEffect } from "react";
import { connect, type ConnectedProps } from "react-redux";
import { Loader } from "semantic-ui-react";

type Props = IWizardStep &
  PropsFromRedux & {
    accountId: number;
    onSelectedChanged?: (templates: number[]) => void;
  };

export const CreateAccountTemplates = (props: Props) => {
  const { accountId, addTemplates, templates, onSelectedChanged } = props;

  const cb = useEventCallback(() => {
    addTemplates(accountId, templates);
  }, [accountId, addTemplates, templates]);

  useEffect(() => {
    props.acceptHandlers?.({
      onFinish: cb,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!accountId) {
    return <Loader active />;
  }

  return <Templates accountId={accountId} onSelectedChanged={onSelectedChanged} />;
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  return {
    templates: state.accounts.availableTemplates.overview.selected,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    addTemplates: bindAction(addTemplatesThunk, dispatch),
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(CreateAccountTemplates);
export default ConnectedComponent;
